export interface Contract {
  id: string;
  userId: string;
  storeId: string;
  plan?: ContractPlan;
  contractType?: ContractType;
  status?: ContractStatus;
  paymentMethod?: ContractPaymentMethod;
  startDate?: Date;
  endDate?: Date;
  salary?: number;
  createdAt?: Date;
  updatedAt?: Date;
}

export enum ContractType {
  CDI = "cdi",
  CDD = "cdd",
  INTERIM = "interim",
  FREELANCE = "freelance",
}

export enum ContractStatus {
  ACTIVE = "active",
  INACTIVE = "inactive",
  EXPIRED = "expired",
}

export enum ContractPaymentMethod {
  CASH = "cash",
  BANK_TRANSFER = "bank_transfer",
  CREDIT_CARD = "credit_card",
  PAYPAL = "paypal",
}

export enum ContractPlan {
  SEVEN_DAYS = 7,
  SIX_DAYS = 6,
  FIVE_DAYS = 5,
  FOUR_DAYS = 4,
}
